function normalizeEventForKey(event = {}) {
  return {
    kind: event.kind || 'unknown',
    resource: event.resource || 'unknown',
    amount: Number.isFinite(event.amount) ? event.amount : null,
    source: event.source || null,
    systemId: event.systemId || null,
    trackerId: event.trackerId || null,
    resourceProfileId: event.resourceProfileId || null,
    level: Number.isFinite(event.level) ? event.level : null,
  };
}

export function createResourceEventKey(event = {}) {
  return JSON.stringify(normalizeEventForKey(event));
}

export function drainResourceEventQueue({
  initialChar,
  initialEvents = [],
  dispatchEvent,
  maxRepeatsPerKey = 3,
  maxSteps = 50,
} = {}) {
  let nextChar = initialChar;
  const queue = Array.isArray(initialEvents) ? [...initialEvents] : [];
  const seenCounts = new Map();
  const dispatched = [];
  const suppressedEvents = [];
  let steps = 0;

  while (queue.length > 0 && steps < maxSteps) {
    const event = queue.shift();
    steps += 1;

    const key = createResourceEventKey(event);
    const seenCount = seenCounts.get(key) || 0;
    if (seenCount >= maxRepeatsPerKey) {
      suppressedEvents.push(event);
      continue;
    }
    seenCounts.set(key, seenCount + 1);

    const response = dispatchEvent?.(nextChar, event, {
      step: steps,
      seenCount: seenCount + 1,
      eventKey: key,
    }) || {};

    if (response.nextChar) {
      nextChar = response.nextChar;
    }

    dispatched.push({
      event,
      dispatchedResult: response.dispatchedResult || null,
    });

    if (Array.isArray(response.emittedEvents) && response.emittedEvents.length > 0) {
      queue.push(...response.emittedEvents);
    }
  }

  const stoppedEarly = queue.length > 0;
  if (stoppedEarly) {
    suppressedEvents.push(...queue);
  }

  return {
    nextChar,
    dispatched,
    suppressedEvents,
    steps,
    stoppedEarly,
  };
}
